import { Breadcrumb } from '@components/breadcrumb';
import { useFragment } from 'react-relay';
import { SearchOverview, SearchResults, searchPageFragment } from './lib';
import type { SearchPageProps } from './types';

export const SearchPage: React.FC<SearchPageProps> = ({ page: pageKey, location }) => {
  const page = useFragment(searchPageFragment, pageKey);
  const searchTerm = (location?.query?.search as string) || '';

  return (
    <div className="relative max-w-[820px] mx-auto [&_h1]:font-normal [&_h3]:font-serif [&_h3]:text-xl [&_h3]:leading-7 [&_h3]:text-black [&_h3]:font-normal [&_h3]:mb-8 max-[1100px]:mx-[25px] max-[1100px]:[&_h1]:mb-4! max-[1100px]:[&_h3]:mb-4 max-[1100px]:[&_h3]:leading-6 max-[1100px]:[.breadcrumb]:pb-[25px]">
      <Breadcrumb data={page.breadcrumbs} />
      <h1>{page.title}</h1>
      <SearchOverview page={page} searchTerm={searchTerm} />
      <SearchResults searchTerm={searchTerm} page={page} />
    </div>
  );
};
